import { render, staticRenderFns } from "./Origin.vue?vue&type=template&id=50230a90&scoped=true&"
import script from "./Origin.vue?vue&type=script&lang=js&"
export * from "./Origin.vue?vue&type=script&lang=js&"
import style0 from "./Origin.vue?vue&type=style&index=0&id=50230a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50230a90",
  null
  
)

export default component.exports